import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

export const ClearBtn = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  right: -1px;
  padding: 5px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: ${({ theme }) => theme.snow};
  background-color: ${({ theme }) => theme.primary};
`


// WEBPACK FOOTER //
// ./src/Components/SigPad/Styles.js